import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/services/api/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private service : AuthService, private route : Router){ }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const redirectUrl = state.url;
    const isLoggedIn = await this.service.IsLoggedIn();

    if (isLoggedIn) {
      return true;
    } else {
      sessionStorage.setItem('redirectUrl', redirectUrl);
      this.route.navigate(['ingresar']);
      return false;
    }
  }

}
